module.exports = __webpack_public_path__ + "img/logo-tripwe-v.36b8af75.png";